import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getUserIdFromStoredJwt } from '@/api/services/auth.service'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'
import type { PhotoCandid } from '@/api/types/photo'

const RECOMMEND_TO_ME_VALUE = 'curated:recommend-to-me'

/** Notifies embedded photo iframes to refresh when recommendations change. */
export function invalidateEmbeddedPhotosCache(): void {
  window.dispatchEvent(new CustomEvent('photos-recommendations-invalidated'))
}

export function useDeletePhotoRecommendation(albumValue: string | null, spreadId?: string | null) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (candidId: string) => {
      const staffId = getUserIdFromStoredJwt()

      if (!staffId) {
        throw new Error('Unable to remove recommendation without a signed-in user')
      }

      await photosService.deletePhotoRecommendation(candidId, staffId)
    },
    onSuccess: (_data, candidId) => {
      queryClient.setQueryData<PhotoCandid[]>(
        queryKeys.photos.albumPhotos(albumValue, spreadId),
        (current) => current?.filter((photo) => photo.candidId !== candidId) ?? []
      )
      invalidateEmbeddedPhotosCache()
    },
  })
}

export { RECOMMEND_TO_ME_VALUE }
